<div class="row row1">
  <div class="col-sm-12 no-left-padding alerts-header">
    <h2 class="overview-header">Alerts and Communications</h2>
  </div>
</div>
<div class="row row2">
  <div class="card">
    <div class="card-header bp-card-header">
      <p class="font-weight-light bp-text card-header-no-icon">Is your Contact Information up to date?</p>
    </div>
    <div class="card-body">
      <div class="row bp-text card-content alarms-content">
        <div class="col-sm-7">
          <span class="bp-text bp-small-text phone-txt">Your Phone Numbers, Emails and Mailing Address are used to create Alerts and Communications.</span>
        </div>
        <div class="col-sm-5">
          <h4 class="red-link-header"><a routerLink="/MyProfile/ContactInfo" class="bp-link-red red-link">UPDATE YOUR CONTACT INFORMATION<i class="fas fa-chevron-right view-more-arrow red-link-arrow"></i></a></h4>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row row4">
  <div class="card">
    <div class="card-header bp-card-header">
      <p class="font-weight-light bp-text card-header-no-icon">Alerts</p>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-sm-12">
          <p class="font-weight-light bp-text">
            Sign up now to receive notifications by text or email.
          </p>
        </div>
      </div>
      <div class="row padding-10">
        <app-flow-alerts></app-flow-alerts>
        <app-vacation-alert></app-vacation-alert>
        <app-cold-weather-alerts></app-cold-weather-alerts>
        <app-water-usage-alerts></app-water-usage-alerts>
      </div>
    </div>
  </div>
</div>




// WEBPACK FOOTER //
// ./src/app/alarm-container/alarm-container.component.html